<template>
	<div id="app" class="emotivi-app container-lg p-0">

			<div class="d-flex flex-row">

				<!-- MENU CONTAINER -->
				<div
					v-if="isLogged && !isPublicPage"
					class="offcanvas-lg offcanvas-start" 
					data-bs-scroll="true"
					tabIndex={-1}
					id="offcanvasMenu"
					aria-labelledby="offcanvasMenuLabel"
				>
					<div class="sticky-top vh-100"> 
						<LeftMenu />
					</div>

				</div>

				<!-- MAIN CONTAINER -->


				<div class="d-flex flex-grow-1 flex-column page-content" :class="{'logged': isLogged}">

						<!-- PAGE HEADER -->
						<div class="page-header sticky-top d-flex flex-row navbar navbar-light ps-2 pe-2 pb-2" data-scroll="0">
							<div class="flex-grow-1 align-content-center" :class="{'d-lg-none': !isPublicPage}">
                <img
                  class="company-logo-mobile"
                  v-if="$store.state.authenticated && $store.state.affiliatedUser.establishments[0].es_avatar"
                  :src="`${this.$config.server_url}${$store.state.affiliatedUser.establishments[0].es_avatar}`"
                  alt=""
                />
                <img v-else class="company-logo-mobile" src="/images/logo_emotivi.png" alt="" />
							</div>
              
							<div v-if="isLogged && !isPublicPage" class="d-flex align-items-center">
								<button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasMenu" aria-controls="offcanvasMenu">	
									<span class="navbar-toggler-icon"></span>
								</button>
							</div>
						</div>

						<div id="app" class="flex-grow-1 ps-2 pe-2">
							<router-view />
						</div>
					</div>

          <div id="wincookie" style="display: none">
              <div style="float: left; cursor: pointer; margin-right: 20px">
                <a href="javascript:void(0);" onclick="closeCookieWin();"
                  ><img src="/images/bt_fermer.png" alt=""
                /></a>
              </div>
              En poursuivant votre navigation sans modifier vos paramètres, vous
              acceptez l'utilisation des cookies ou technologies similaires pour
              disposer de services et d'offres adaptés à vos centres d'intérêts ainsi
              que pour la sécurisation des transactions sur notre site. Pour plus
              d'informations, <a href="/files/CGU-Emotivi-20201209.pdf">cliquez ici</a>
          </div>
        </div>

			</div>

</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {
      alertcookieshow: false,
      confirmLogoutDialog: false,
      drawer: true,
      nbClientSuivi: 0,
      nbBienSuivi: 0,
      //user: null,
      search: "",
      routeActive: this.$route.meta.menu
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },

		isLogged() {
			return this.$store.state.authenticated || this.$store.state.connected;
		},

    isLoginPage() {
      return this.$route.name === "login";
    },

    isResetPage() {
      return this.$route.name === "resetpass";
    },

    isPublicPage() {
      return this.$route.meta.publicpage;
    }
  },
  watch: {
    $route(to, from) {
      this.routeActive = this.$route.meta.menu;
    }
  },
  async created() {
  },
  async mounted() {


    console.log("route", this.$route, this.$router)

    let ok = this.$cookie.get("belsunce_allertcookie");

    if (!ok || ok != "ok") this.alertcookieshow = true;

    window.addEventListener("click", this.onWindowClick);

    //load Stripe js lib
    let stripe = document.createElement('script')

    stripe.setAttribute('src', 'https://js.stripe.com/v3/')

    document.head.appendChild(stripe)
  },
  destroyed() {
    window.removeEventListener("click", this.onWindowClick);
  },



  methods: {

    gotoPart(page, anchor) {
      this.$router.push("/" + page);
      window.setTimeout(() => {
        if (anchor) {
          let el = document.getElementById(anchor);
          if (el) window.scrollTo(0, el.offsetTop);
        }
      }, 300);
    },

    onWindowClick() {

    },

    backToMainSite() {
      window.open(this.$config.web_url, "_self");
    },

    goToAccount(path) {
      let urlPath = "/private/home";
      if (path) urlPath = path;
      this.$router.push(urlPath);
    }
  }
};
</script>
<style lang="scss">
@import "../node_modules/bootstrap/scss/bootstrap.scss";
@import "./scss/styles.scss";

#offcanvasMenu {
  min-width: 300px;
  max-width: 300px;
}

.page-content {
	background-color: #fff;
	min-height: 100vh;
}

.page-header {
	background-color: #fff;
	height: 66px;
}

.company-logo-mobile {
  height: 40px;
  width: auto;
}
</style>
